import { Row, DBRow as DBRowOrig } from '@cloudio-saas/datasource-types';
import { isNull } from 'utils/isEmpty';

/**
 * Returns true if the given record is fetched from the server, false otherwise
 * @param row the record to check
 * @returns true if the given record is fetched from the server, false otherwise
 */
function isFromDB<T>(row?: Row<T> | null): row is DBRow<T> {
  return !isNull(row) && row._rs !== 'N' && row._rs !== 'I';
}

export interface Records<T> {
  [key: string]: Row<T>;
}

export type DBRow<T> = DBRowOrig<T> & { _id: string };

export { isFromDB };
